<template>
    <v-container class="footer" fluid>
      <v-row>
        <v-col class="mt-4">
            <v-img width="200" class="mx-auto" :src="LogoWhite" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn color='white' text target="_blank" href="https://www.conclimate.de/kontakt" rounded class="my-2">{{ $t('contact') }}</v-btn>
          <v-btn color='white' text target="_blank" href="https://www.conclimate.de/impressum" rounded class="my-2">{{ $t('imprint') }}</v-btn>
          <v-btn color='white' text target="_blank" href="https://www.conclimate.de/datenschutz" rounded class="my-2">{{ $t('privacy') }}</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <p class="caption">ConClimate GmbH | Schatzbogen 39 | 81829 München |
          Telefon: +49 (0) 89 420490-811 | E-Mail: info@conclimate.de</p>
        </v-col>
      </v-row>
      <v-row  class="mx-auto align-center justify-center lang">
        <v-col  cols="3" class="text-center">
          <v-select v-model="selectedLanguage" :dark="true" :items="languages" :label="$t('label')"     />
        </v-col>
      </v-row>
    </v-container>

</template>

<i18n>
{
  "en": {
    "contact": "Contact",
    "imprint": "Imprint",
    "privacy": "Data Privacy",
    "label": "Language"
  },
  "de": {
    "contact": "Kontakt",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "label": "Sprache"
  }
}
</i18n>

<script>
import conClimateLogo from '@/assets/conClimateLogoWebFinal.svg';
import LogoWhite from '@/assets/conClimateLogoWebWhite.svg';

export default {
  name: 'Footer',
  data() {
    return {
      conClimateLogo,
      LogoWhite,
      languages: ['Deutsch', 'English'],

    };
  },
  computed: {
    themeProps() {
      return {
        dark: true,
        light: false,
      };
    },
    selectedLanguage: {
      get() {
        const lang = this.$root.$i18n.locale;
        console.log('Lang', lang);
        if (lang === 'en') {
          return 'English';
        }
        return 'Deutsch';
      },
      set(val) {
        if (val === 'English') {
          this.$root.$i18n.locale = 'en';
        } else {
          this.$root.$i18n.locale = 'de';
        }
      },
    },
  },
  methods: {
    changeLanguage() {
      console.log('Change Language', this.selectedLanguage);
      if (this.selectedLanguage === 'English') {
        this.$root.$i18n.locale = 'en';
      } else {
        this.$root.$i18n.locale = 'de';
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.footer {
  background-color: #124d7b;
  color: white;
}

.lang {
  background-color:  #124d7b !important;
  color: white !important;
}

.the-center {
  width: 100%;
  margin: 0px auto !important;
}
</style>
